module.exports = __webpack_public_path__ + "img/transitToLanding.82345a31.svg";